import React, { useCallback } from 'react';
import FiltersModal from 'utils/components/FiltersModal/FiltersModal';

import './ExpertiseFiltersModal.scss';
import {
    ExpertiseColumn,
    expertiseColumnDefinitions,
} from '../ExpertiseColumnDefinitions';
import { useDispatchUpdateFilters } from 'widgets/store/grid/filters/dispatcher';
import { FilterState } from 'widgets/store/grid/filters/FilterState';
import { useSelectExpertiseData } from 'widgets/expertise/store/stream/selectors';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

export interface ExpertiseFiltersModalProps {
    trigger: React.ReactElement;
    visibleColumns: ExpertiseColumn[];
    filters: FilterState<ExpertiseColumn>[];
}

export default function ExpertiseFiltersModal(
    props: ExpertiseFiltersModalProps
) {
    const { visibleColumns, filters, trigger } = props;
    const data = useSelectExpertiseData();

    const dispatchUpdateFilters = useDispatchUpdateFilters();
    const { editedColumnNames } = useWidgetEditedColumnNames();

    const onUpdateFilters = useCallback(
        (nextFilters: FilterState<ExpertiseColumn>[]) => {
            dispatchUpdateFilters(nextFilters);
        },
        [dispatchUpdateFilters]
    );

    return (
        <FiltersModal
            columnDefinitions={expertiseColumnDefinitions}
            data={data}
            editedColumnNames={editedColumnNames}
            visibleColumns={visibleColumns}
            filters={filters}
            selectedRowIndexes={[]}
            trigger={trigger}
            onUpdateFilters={onUpdateFilters}
        />
    );
}
